//
// Product page price display
//

// Class selectors
const MODULE_CLASS = '.js-product-type__tab';
const FORM_CLASS = '.js-product-variant-add-to-cart-form';
const QTY_SPIN_CLASS = '.js-product-variant-qty-spin';
const QTY_FIELD_CLASS = '.js-product-variant-qty';
const PRODUCT_VARIANT_PRICE_CLASS = '.js-product-variant-unformatted-price';
const PRODUCT_VARIANT_PRICE_DISPLAY_CLASS = '.js-product-variant-price';

// Sale specific vars
const PRODUCT_VARIANT_OLD_PRICE_CLASS = '.js-product-variant-unformatted-old-price';
const PRODUCT_VARIANT_OLD_PRICE_DISPLAY_CLASS = '.js-product-variant-old-price';

// Hedging specific vars
const HEDGING_FORMS_CLASS = ".js-product-variant-add-to-cart-form[data-product-variant-type='hedgingTransplants']";
const HEDGING_MULTIPLIER_FIELD_CLASS = '.js-product-hedging-multiplier-input';
const HEDGING_MULTIPLIER_CLASS = '.js-product-variant-hedging-multiplier';

// Native Mixed hedge var
const NATIVE_MIXED_QTY_CLASS = '.js-product-variant-qty-hedging-premix';

export default class ProductPriceMultiplier {
  constructor() {
  }

  init() {
    this.el = document.querySelector(MODULE_CLASS);
    if (!this.el) return;

    // Define all variant forms
    this.productVariantForms = document.querySelectorAll(FORM_CLASS);
    // Define hedging multipler input field
    this.hedgingMultiplierLengthField = document.querySelector(HEDGING_MULTIPLIER_FIELD_CLASS);

    this.addEventToProductVariantForms();

    // Add hedging multiplier event, if it exists
    if(this.hedgingMultiplierLengthField) {
      this.addEventToProductHedgingMultiplier();
    }

  }

  priceCalculate(qtyNumberField, form) {

    // Set variables
    let currentQty = parseInt(qtyNumberField.value);
    const volumePricing = parseInt(form.dataset.productVariantVolumePricing);
    const displayPriceText = form.querySelector(PRODUCT_VARIANT_PRICE_DISPLAY_CLASS);

    // Get the base price
    let basePrice = parseFloat(form.querySelector(PRODUCT_VARIANT_PRICE_CLASS).value);
    // Create variable for new price to update
    let newPrice = basePrice;

    // Check if this variant has volume pricing, or is 0 or NaN (When you clear the input field)
    // Volume pricing will either be 0 or 1 on the form element
    if (volumePricing === 0 || currentQty === 0 || isNaN(currentQty)) {

      // Handle display if NaN (instead of showing £NaN)
      if (isNaN(currentQty)) {
        newPrice = 0;
      } else {
        // Else if no volume pricing, calculate new price
        newPrice = currentQty * basePrice;
      }

      //
      // Sale specific code
      //
      const displayOldPriceText = form.querySelector(PRODUCT_VARIANT_OLD_PRICE_DISPLAY_CLASS);

      if (displayOldPriceText) {
        let oldBasePrice = parseFloat(form.querySelector(PRODUCT_VARIANT_OLD_PRICE_CLASS).value);
        let updatedOldPrice = oldBasePrice;

        if (isNaN(currentQty)) {
          updatedOldPrice = 0;
        } else {
          // Sale price
          updatedOldPrice = currentQty * oldBasePrice;
        }

        // Update the old price
        this.priceUpdate(displayOldPriceText, updatedOldPrice);
      }

      // Update price
      this.priceUpdate(displayPriceText, newPrice);

      // Exit
      return;
    }

    //
    // Volume pricing
    //
    // Get the relevant object for the volume pricing array
    const productType = form.dataset.productVariantType;
    // Find the array via the Product Type variable
    const productTypeVolumePricingArray = productVariantVolumeDiscount[productType];
    // Get the current product variant ID
    const currentProductVariantId = parseInt(form.dataset.productVariantId);

    //
    // Find: The active price array for this variant
    //
    function findVolumePriceArray(variant) {
      return variant.productVariantId === currentProductVariantId;
    }
    const currentProductVariantArray = productTypeVolumePricingArray.find(findVolumePriceArray);
    // Grab the current product variant prices array
    const currentProductVariantPriceArray = currentProductVariantArray['productVariantVolumePrices'];

    //
    // Filter: Compare the current qty to the volume pricing array and find closest but lower
    // this will potentially leave you with multiple results, so use array pop to grab the last item
    function filterArrayByQty(qty) {
      return currentQty >= qty.minQty
    }
    const filteredProductVariantPriceArray = currentProductVariantPriceArray.filter(filterArrayByQty);

    // Get last item in array
    const activeProductVariantPriceArray = filteredProductVariantPriceArray.pop();

    // Set the new base price via the active product array
    basePrice = activeProductVariantPriceArray.productVariantPriceIncTax;

    // Calculate the new price
    newPrice = currentQty * basePrice;

    // Update price
    this.priceUpdate(displayPriceText, newPrice);
  }

  //
  //  Update price display
  //
  priceUpdate(displayPriceText, newPrice) {
    // Format price
    const formattedPrice = this.formatPrice(newPrice);
    // Update price field with new price
    displayPriceText.innerText = formattedPrice;
  }

  //
  //  Format price field
  //
  formatPrice(priceUnformatted) {
    return priceUnformatted.toLocaleString('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2  });
  }

  // Update number qty input field
  qtySpinButtonUpdate(qtySpinButton, qtyNumberField, form) {

    // Get direction of spin button
    const qtySpinDirection = qtySpinButton.dataset.productVariantQtySpin;

    // Increase number up or down
    if (qtySpinDirection === 'up') {
      qtyNumberField.stepUp();
    } else {
      qtyNumberField.stepDown();
    }

    // Now update the price
    this.priceCalculate(qtyNumberField, form);
  }

  //
  // Hedging Length Multiplier
  //
  hedgingMultiplierUpdate(multiplierLengthField) {

    const hedgingMultiplierLength = multiplierLengthField.value;

    // Get all product forms for product type hedging only
    const hedgingProductVariantForms = document.querySelectorAll(HEDGING_FORMS_CLASS);

    // Get multiplier amount for each form row from data array
    hedgingProductVariantForms.forEach((form) => {
      const hedgingMultiplierValue = form.querySelector(HEDGING_MULTIPLIER_CLASS).value;
      const productVariantQtyField = form.querySelector(QTY_FIELD_CLASS);

      // Set new quantity via the length field
      let newQty = hedgingMultiplierLength * hedgingMultiplierValue

      // Make sure the qty is a positive number
      if(newQty <= 0) {
        newQty = 1;
      }

      // Update qty field for all forms, using multiplier, make sure it's an Integer
      productVariantQtyField.value = Math.round(newQty);

      // Now update the price
      this.priceCalculate(productVariantQtyField, form);

    });
  }

  //
  // Native Mixed Hedge quantity limiter (fired on change rather than keyup)
  //
  quantityLimiter(qtyNumberField, form) {
    let currentQty = qtyNumberField.value;
    if (currentQty < 10) {
      qtyNumberField.value = 10;
    }
    this.priceCalculate(qtyNumberField, form);
  }

  //
  // Events
  //
  // Product variant forms
  addEventToProductVariantForm(form) {

    const qtyNumberField = form.querySelector(QTY_FIELD_CLASS);
    const qtySpinButtons = form.querySelectorAll(QTY_SPIN_CLASS);
    const qtyNumberMixedHedgeField = form.querySelector(NATIVE_MIXED_QTY_CLASS);

    qtySpinButtons.forEach((element) => {
      element.addEventListener('click', (event) => {
        this.qtySpinButtonUpdate(event.currentTarget, qtyNumberField, form);
      });
    });

    qtyNumberField.addEventListener('input', () => {
      this.priceCalculate(qtyNumberField, form);
    });

    //
    // Premix Hedging only
    //
    // Force user to have a minimum quantity of 10
    if (qtyNumberMixedHedgeField) {
      qtyNumberMixedHedgeField.addEventListener('change', () => {
        this.quantityLimiter(qtyNumberField, form);
      })
    }
  }

  // Bind events to each product variant form
  addEventToProductVariantForms() {
    this.productVariantForms.forEach(this.addEventToProductVariantForm.bind(this));
  }

  // Bind events to each hedging multiplier field
  addEventToProductHedgingMultiplier() {
    this.hedgingMultiplierLengthField.addEventListener('input', (event) => {
      this.hedgingMultiplierUpdate(event.currentTarget);
    });
  }

}